import React from 'react';
import welfare from '../../assets/images/welfare.png';
import invest from '../../assets/images/invest.png';
import health from '../../assets/images/health.png';
import rewards from '../../assets/images/rewards.png';
import bonds from '../../assets/images/bonds.png';
import assistance from '../../assets/images/assistance.png';

const PerksOfTribe = () => {
  return ( 
    <div className="perks-of-tribe perks">
      <p className="font-weight-extrabold fs-18 perks">PERKS OF THE TRIBE</p>
      <p className="font-weight-thin fs-85 text-primary perks">SmartDrive cares<br></br> for its Tribe</p>
      <div className="row">
        <div className="col-md-4">
          <p className="text-gray fs-14">At SmartDrive, we care about each<br></br> employee intently, by ensuring their<br></br> happiness and encouraging them to<br></br> reach their highest potential.</p>
        </div>
        <div className="col-md-8">
          <div className="row">
          <div className="col-md-6 mt-5">
              <img src={welfare} alt="Welfare" />
              <p className="fs-18 text-gray mt-4">Welfare for Women</p>
              <p className="fs-14 text-gray">Our inclusive work environment facilitates<br></br> the employment of over xx% of women in<br></br> our workforce.</p>
            </div>
            <div className="col-md-6 mt-5">
              <img src={invest} alt="Invest" />
              <p className="fs-18 text-gray mt-4">We invest in you</p>
              <p className="fs-14 text-gray">We offer our associates several<br></br> opportunities to further their growth and<br></br> groom them for leadership roles through<br></br> training workshops and classes.</p>
            </div>
            <div className="col-md-6 mt-5">
              <img src={health} alt="Health" />
              <p className="fs-18 text-gray mt-4">Health & Wellness</p>
              <p className="fs-14 text-gray">We provide free wholesome food at the<br></br> cafeteria during working hours, conduct<br></br> health promotion activities and free<br></br> weekly doctor consultations. </p>
            </div>
            <div className="col-md-6 mt-5">
              <img src={rewards} alt="Rewards" />
              <p className="fs-18 text-gray mt-4">Rewards & Recognition</p>
              <p className="fs-14 text-gray">Our unique program consisting of Team<br></br> Awards and special recognition, allows<br></br> associates to be nominated by their<br></br> peers and managers on a monthly and<br></br> quarterly basis.</p>
            </div>
            <div className="col-md-6 mt-5">
              <img src={bonds} alt="Bonds" />
              <p className="fs-18 text-gray mt-4">Building Bonds</p>
              <p className="fs-14 text-gray">Celebrations, birthdays, and activities play<br></br> a key role in bringing the tribe together to<br></br> create an inclusive environment.</p>
            </div>
            <div className="col-md-6 mt-5">
              <img src={assistance} alt="Assistance" />
              <p className="fs-18 text-gray mt-4">Employee Assistance Program</p>
              <p className="fs-14 text-gray">We stand by our associates and help<br></br> them find their way out of their problems,<br></br> through counseling sessions, de-<br></br>addiction sessions, and reward them for<br></br> defeating their demons.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
   );
}
 
export default PerksOfTribe;